import { JWTTokens } from '../apis/kstadiumAPI/logIn/types';
import { decodePayloadFromJWT } from '../utils/jwt';

type AccessToken = `default` | `disposable` | undefined;
export interface KStadiumJWTPayload {
  info: {
    account: string;
  };
}

const KSTADIUM_ACCESS_TOKEN_KEY = `kstadiumAccessToken`;
const KSTADIUM_REFRESH_TOKEN_KEY = `kstadiumRefreshToken`;
const KSTADIUM_DISPOSABLE_ACCESS_TOKEN_KEY = `kstadiumDisposableTokenToken`;

export const getAccessToken = (type: AccessToken = `default`) =>
  type === `default`
    ? localStorage.getItem(KSTADIUM_ACCESS_TOKEN_KEY)
    : localStorage.getItem(KSTADIUM_DISPOSABLE_ACCESS_TOKEN_KEY);

export const getRefreshToken = () =>
  localStorage.getItem(KSTADIUM_REFRESH_TOKEN_KEY);

export const setTokenInLocalStorage = ({
  accessToken,
  refreshToken,
}: JWTTokens) => {
  localStorage.setItem(KSTADIUM_ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(KSTADIUM_REFRESH_TOKEN_KEY, refreshToken);
};

export const removeTokenInLocalStorage = () => {
  localStorage.removeItem(KSTADIUM_ACCESS_TOKEN_KEY);
  localStorage.removeItem(KSTADIUM_REFRESH_TOKEN_KEY);
  localStorage.removeItem(KSTADIUM_DISPOSABLE_ACCESS_TOKEN_KEY);
  window.location.replace(`/bridge`);
};

export const setDisposableTokenTokenInLocalStorage = (accessToken) =>
  localStorage.setItem(KSTADIUM_DISPOSABLE_ACCESS_TOKEN_KEY, accessToken);

export const removeDisposableTokenTokenInLocalStorage = () =>
  localStorage.removeItem(KSTADIUM_DISPOSABLE_ACCESS_TOKEN_KEY);

export const getTokenPayload = () => {
  const accessToken = getAccessToken();
  return accessToken
    ? decodePayloadFromJWT<KStadiumJWTPayload>(accessToken)
    : null;
};
